import React, { useState, useEffect } from "react";
import DealerIncentiveProgramListingCompnent from "./listing.page";
import LoadingComponent from "components/loading";
import { useHistory } from "react-router-dom"
// import LoadingComponent from 'components/loading';
import { NEW_INCENTIVE_PROGRAM_PAGE } from "../../../config/stockflow.route"
import { useSelector } from "react-redux";
import { getLang } from "app/feature/constants";
import { AccessRights } from "lib/constants/accessRights";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function DealerIncentiveProgramListingContainer() {
  const history = useHistory()

  const [ activeIndex, setActiveIndex ] = useState(0);
  const hasStockflowViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_INCENTIVE_PROGRAM_READ));
  const hasStockflowAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_INCENTIVE_PROGRAM_CREATE));
  const lang = useSelector(state => state.constant.languages);
  const tabLabels = [getLang(lang, 'label.DEALER_INCENTIVE_POINTS')];

  useEffect(() => {
    if (!hasStockflowViewAccessRight) {
      history.push('/admin/dashboard')
    }
  }, [history, hasStockflowViewAccessRight])

  if (!hasStockflowViewAccessRight) return <LoadingComponent />;

  const handleChange = (event, index) => {
    setActiveIndex(index)
  }

  const handleAddIncentiveProgram = () => {
    history.push( NEW_INCENTIVE_PROGRAM_PAGE )
  }

  return (
    <>
      <DealerIncentiveProgramListingCompnent
        hasStockflowAddAccessRight={hasStockflowAddAccessRight}
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        handleAddIncentiveProgram={handleAddIncentiveProgram}
        lang={lang}
      />
    </>
  )
}

export default DealerIncentiveProgramListingContainer
